<div class="content">
  <article class="enrichment-source-fields" [ngClass]="[needsSaving() ? 'not-saved' : 'saved', saving ? 'saving' : '']">
    <section class="source-fields-section">
      <h2 class="heading-underline">Enrichment record identification fields</h2>
      <p class="section-description">{{ candidateEntityLabel }} fields used to match a Bullhorn record with a record in the Enrichment data</p>
      <app-enrichment-source-fields (needsSavingEmitter)="updateSourceFieldsNeedSaving($event)">
      </app-enrichment-source-fields>
    </section>
  </article>
  <article [ngClass]="[needsSaving() ? 'not-saved' : 'saved', saving ? 'saving' : '']">
    <section class="field-mappings-section">
      <app-enrichment-field-mappings (needsSavingEmitter)="updateFieldMappingsNeedSaving($event)">
      </app-enrichment-field-mappings>
    </section>

    @if (canSave()) {
      <section class="footer-btns" [ngClass]="[needsSaving() ? 'not-saved' : 'saved', saving ? 'saving' : '']">
        <button theme="nav" (click)="save()" appRipple>
          <i class="bhi-save icon-left"></i>
          <span>Sav</span><span class="not-saved-text">e</span><span class="saving-text">ing</span><span class="saved-text">ed</span>
        </button>
      </section>
    }
  </article>
</div>
